import React from "react";
import log01 from '../assets/img/logo.png';

const Pageloader = () => {
  return (
    <div className="pageLoader">
        <h4>Welcome to</h4>
        <img src={log01} alt="Loading..." className="pageloader-logo" />  
    </div>
  );
};

export default Pageloader;